import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconArrowLeftApollo = props => {
  if (props.id !== "_svgiconarrowleftapollo") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 24 24" {...props}><path fill="#202020" fillRule="evenodd" d="M8.727 6.2l-5.278 5.024c-.598.57-.598 1.428 0 1.998l5.278 5.023c.26.248.705.269.996.048.29-.22.316-.6.056-.846l-4.858-4.624H19.65c.39 0 .706-.269.706-.6 0-.332-.316-.6-.706-.6H4.92l4.86-4.624a.548.548 0 00.18-.399c0-.165-.08-.33-.236-.448a.795.795 0 00-.996.048" /></svg>;
};

SvgIconArrowLeftApollo.displayName = "_svgiconarrowleftapollo";
SvgIconArrowLeftApollo.propTypes = {
  id: PropTypes.string
};
SvgIconArrowLeftApollo.defaultProps = {
  id: ''
};
export default SvgIconArrowLeftApollo;